/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

const ChevronDown = () => (
  <svg 
    width="14" 
    height="14" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M6 9l6 6 6-6"/>
  </svg>
);

export default ChevronDown;

